import { useId, useReducer } from "react";
import { Mui } from "@osu/react-ui";
import Wrapper from "./Wrapper";
import { selectDeadlinesForYear } from "../../../../../services/submissionPeriod/slices";
import { useSelector } from "react-redux";
import AdminSessionQuestions from "./Questions";
import DashboardAlert from "../../../../../Dashboard/components/Alert";

const initialState = {
  touched: [],
  formData: {
    calendarType: "FGC",
    description: "",
    end: null,
    formsCloseDate: null,
    formsOpenDate: null,
    label: "",
    start: null,
  },
  errors: {},
};

function formReducer(state, action) {
  const touched = new Set(state.touched);
  switch (action.type) {
    case "SET_FIELD":
      touched.add(action.field);
      return {
        ...state,
        touched: [...touched],
        formData: { ...state.formData, [action.field]: action.value },
        errors: { ...state.errors, [action.field]: null },
      };
    case "SET_ERRORS":
      return { ...state, errors: action.errors };
    case "RESET":
      return {
        ...initialState,
        formData: { ...initialState.formData, ...action.data },
      };
    default:
      return state;
  }
}

function SessionFormModal({ open, onClose, onSubmit, year, period, session, isSaving }) {
  const initialData =  useSelector((state) => {
    if(Object.keys(session || {})?.length) {
      return session
    }
    return selectDeadlinesForYear(state, year, period)?.[0] || {}
  })
  const [state, dispatch] = useReducer(formReducer, {
    ...initialState,
    formData: { ...initialState.formData, ...initialData },
  });
  const id = useId()
  const handleChange = (value, field) => {
    dispatch({ type: "SET_FIELD", field, value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!state.formData.start) newErrors.start = "Start date is required";
    if (!state.formData.end) newErrors.end = "End date is required";
    if (!state.formData.formsOpenDate)
      newErrors.formsOpenDate = "Forms open date is required";
    if (!state.formData.formsCloseDate)
      newErrors.formsCloseDate = "Forms close date is required";

    dispatch({ type: "SET_ERRORS", errors: newErrors });
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      onSubmit({
        formData: state.formData,
        touched: state.touched,
      });
    }
  };
  
  const error =
    !year || !period
      ? `Year and Period are required to create or edit a session.`
      : false;
  const alertProps = {}
  if(error) {
    alertProps.message = error
    alertProps.severity = "error"
  } else if (isSaving) {
    alertProps.message = `Updating session information for Year: ${year}, Period: ${period}`
  }
  let submitLabel = ''
  if(initialData?.pk) {
    submitLabel = isSaving ? `Updating` : `Update`
  } else {
    submitLabel = isSaving ? `Creating` : `Create`
  }
  submitLabel += ` Session`

  return (
    <Wrapper open={open} onClose={onClose} year={year} period={period}>
      <DashboardAlert 
        {...alertProps}
        sx={{
          mb: 1
        }}
      />
      <form onSubmit={handleSubmit}>
        <Mui.Stack spacing={3}>
          <AdminSessionQuestions 
            id={id}
            errors={state.errors}
            handleChange={handleChange}
            formData={state.formData}
          />
          <Mui.Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "flex-end",
              mt: 4,
            }}
          >
            <Mui.Button disabled={isSaving} type="button" variant="outlined" onClick={onClose}>
              Cancel
            </Mui.Button>
            <Mui.Button loading={isSaving} loadingPosition="start" disabled={isSaving} type="submit" variant="contained">
              {submitLabel}
            </Mui.Button>
          </Mui.Box>
        </Mui.Stack>
      </form>
    </Wrapper>
  );
}

export default SessionFormModal;
